import classNames from "classnames";
import { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export interface RouteTabsProps {
  children: ReactNode;
  ariaLabel: string;
  className?: string;
}

export function RouteTabs({ children, ariaLabel, className }: RouteTabsProps) {
  return (
    <nav
      aria-label={ariaLabel}
      className={classNames("border-b border-divider", className)}
    >
      <div className="flex gap-4">{children}</div>
    </nav>
  );
}

export interface RouteTabProps {
  to: string;
  label: ReactNode;
  end?: boolean;
}

export function RouteTab({ to, label, end = false }: RouteTabProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        classNames(
          "inline-flex min-h-target items-center px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
          {
            "border-primary text-primary": isActive,
            "border-transparent text-muted hover:text-default": !isActive,
          },
        )
      }
    >
      {label}
    </NavLink>
  );
}
